module.exports = __webpack_public_path__ + "static/media/ES-Udl.33e68496.png";